import api from './axiosConfig';

const normalizeTableArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data?.tables)) return payload.data.tables;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.tables)) return payload.tables;
  return [];
};

const tableAPI = {
  normalizeTableArray,

  async getTables(storeId = '') {
    const params = {};
    if (storeId) params.storeId = String(storeId);

    const response = await api.get('/tables', { params });

    return normalizeTableArray(response.data);
  },

  async createTable(payload) {
    const response = await api.post('/tables', payload);
    return response.data;
  },

  async updateTable(tableId, payload) {
    const response = await api.put(`/tables/${tableId}`, payload);
    return response.data;
  },

  async deleteTable(tableId) {
    const response = await api.delete(`/tables/${tableId}`);
    return response.data;
  },

  async mergeTables(payload) {
    const response = await api.post('/tables/merge', payload);
    return response.data;
  },

  async splitTable(payload) {
    const response = await api.post('/tables/split', payload);
    return response.data;
  },

  async moveTable(payload) {
    const response = await api.post('/tables/move', payload);
    return response.data;
  },

  async bulkUpdateTables(payload) {
    const response = await api.put('/tables/bulk', payload);
    return response.data;
  },

  async getUserStores() {
    const response = await api.get('/users/stores');

    const payload = response.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.stores)) return payload.stores;
    return [];
  },

  async getActiveCartByTable(tableNumber) {
    if (!tableNumber) return null;

    try {
      const response = await api.get(`/carts/table/${encodeURIComponent(tableNumber)}`);

      const cart = response.data;
      if (!cart || cart.billedOut) return null;
      return cart;
    } catch (error) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
};

export default tableAPI;